export default "__VITE_ASSET__t$UfAME$__"